import React, { useState } from 'react';
import EmailComposer from '../components/EmailComposer';
import SignatureSettings from '../components/SignatureSettings';
import Inbox from '../components/Inbox';
import './EmailHub.css';

export default function EmailHub() {
  const [showComposer, setShowComposer] = useState(false);
  const [showSignatureSettings, setShowSignatureSettings] = useState(false);
  const [activeTab, setActiveTab] = useState<'compose' | 'inbox' | 'sent'>('compose');

  const handleEmailSent = (result: any) => {
    // Show success message or refresh inbox
    console.log('Email sent:', result);
  };

  return (
    <div className="email-hub">
      <div className="email-hub-header">
        <h1>Email Center</h1>
        <div className="header-buttons">
          <button 
            className="settings-button"
            onClick={() => setShowSignatureSettings(true)}
          >
            ⚙️ Signature Settings
          </button>
          <button 
            className="compose-button"
            onClick={() => setShowComposer(true)}
          >
            ✉️ Compose New Email
          </button>
        </div>
      </div>

      <div className="email-tabs">
        <button
          className={`tab-button ${activeTab === 'compose' ? 'active' : ''}`}
          onClick={() => setActiveTab('compose')}
        >
          Compose
        </button>
        <button
          className={`tab-button ${activeTab === 'inbox' ? 'active' : ''}`}
          onClick={() => setActiveTab('inbox')}
        >
          Inbox
        </button>
        <button
          className={`tab-button ${activeTab === 'sent' ? 'active' : ''}`}
          onClick={() => setActiveTab('sent')}
        >
          Sent Items
        </button>
      </div>

      <div className="email-content">
        {activeTab === 'compose' && (
          <div className="compose-section">
            <p>Click the "Compose New Email" button to start writing an email.</p>
            <p>You can also compose emails directly from claim details.</p>
          </div>
        )}
        
        {activeTab === 'inbox' && (
          <div className="inbox-section">
            <Inbox />
          </div>
        )}
        
        {activeTab === 'sent' && (
          <div className="sent-section">
            <p>Sent items functionality coming in Phase 2.</p>
            <p>You will be able to view all emails sent through the PCP system.</p>
          </div>
        )}
      </div>

      {showComposer && (
        <EmailComposer
          onClose={() => setShowComposer(false)}
          onSent={handleEmailSent}
        />
      )}
      
      {showSignatureSettings && (
        <div className="signature-settings-modal">
          <SignatureSettings
            onClose={() => setShowSignatureSettings(false)}
          />
        </div>
      )}
    </div>
  );
}